// extracted by mini-css-extract-plugin
export default {"nodeContainer":"node_nodeContainer__uf0yS","nodeHeading1":"node_nodeHeading1__0+0go","nodeHeading2":"node_nodeHeading2__WPhZp","nodeStartContainer":"node_nodeStartContainer__lQP82"};